(function () {
  var FALLBACK = 'cart-upsell-v2';
  var SECTIONS = ['cart-upsell', 'cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];
  var shownTag = null;
  var root = function () { return window.Shopify.routes.root; };

  function arm() { return document.documentElement.getAttribute('data-qt-arm') || 'a'; }

  function activeButton() {
    return document.querySelector('#cart-upsell .qt-arm--' + arm() + ' [data-qt-upsell-add]')
        || document.querySelector('#cart-upsell [data-qt-upsell-add]');
  }

  function marker() { return document.querySelector('#cart-upsell [data-qt-sub]'); }

  function track(name, detail) {
    document.dispatchEvent(new CustomEvent('qetoe:' + name, { detail: detail }));
    if (window.dataLayer) window.dataLayer.push(Object.assign({ event: name }, detail));
  }

  function swap(id, html) {
    var target = document.getElementById(id);
    if (!target || !html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var source = parsed.querySelector('.shopify-section') || parsed.body;
    if (source) target.innerHTML = source.innerHTML;
  }

  function clearOurDiscount() {
    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: '' })
    }).catch(function (e) { console.warn('[cart-upsell] clear failed', e); });
  }

  function guardSubscription() {
    var m = marker();
    if (!m || m.getAttribute('data-qt-sub') !== 'true') return;
    var ours = (m.getAttribute('data-qt-code') || '').toUpperCase();
    if (!ours) return;
    fetch(root() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var codes = (c.discount_codes || []).map(function (d) { return (d.code || '').toUpperCase(); });
        if (codes.indexOf(ours) === -1) return;
        return clearOurDiscount().then(function () {
          track('cart_upsell_discount_cleared', { reason: 'subscription_in_cart', code: ours });
        });
      })
      .catch(function (e) { console.warn('[cart-upsell] guard failed', e); });
  }

  function noteImpression() {
    var button = activeButton();
    if (!button) return;
    var tag = button.getAttribute('data-offer-tag') || FALLBACK;
    if (shownTag === tag) return;
    shownTag = tag;
    track('cart_upsell_shown', {
      upsell_arm: button.getAttribute('data-arm') || arm(),
      upsell_segment: button.getAttribute('data-seg') || 'std',
      upsell_variant_id: button.getAttribute('data-variant-id'),
      upsell_offer: tag
    });
  }

  function applyDiscount(code) {
    if (!code) return clearOurDiscount().then(function () { return false; });
    return fetch(root() + 'discount/' + encodeURIComponent(code), {
      method: 'GET', redirect: 'follow', credentials: 'same-origin'
    }).then(function () { return true; })
      .catch(function (e) { console.warn('[cart-upsell] discount failed', e); return false; });
  }

  function addUpsell(button) {
    var variantId = button.getAttribute('data-variant-id');
    var tag = button.getAttribute('data-offer-tag') || FALLBACK;
    var whichArm = button.getAttribute('data-arm') || arm();
    var seg = button.getAttribute('data-seg') || 'std';
    var code = button.getAttribute('data-discount-code');
    if (!variantId) return;

    button.setAttribute('aria-busy', 'true');

    applyDiscount(code)
      .then(function (applied) {
        return fetch(root() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: 1, properties: { _upsell: tag } }],
            sections: SECTIONS.join(','),
            sections_url: window.location.pathname
          })
        }).then(function (r) { return r.json(); }).then(function (d) { d.__disc = applied; return d; });
      })
      .then(function (data) {
        if (data.status) throw new Error(data.description || 'Add to cart failed');
        var sections = data.sections || {};
        swap('cart-upsell', sections['cart-upsell']);
        swap('cart-notification-button', sections['cart-notification-button']);
        swap('cart-icon-bubble', sections['cart-icon-bubble']);

        var added = data.items && data.items[0];
        if (added && sections['cart-notification-product']) {
          var host = document.getElementById('cart-notification-product');
          var doc = new DOMParser().parseFromString(sections['cart-notification-product'], 'text/html');
          var node = doc.querySelector('#cart-notification-product-' + added.id);
          if (host && node) host.innerHTML = node.outerHTML;
        }

        track('cart_upsell_accepted', {
          upsell_arm: whichArm,
          upsell_segment: seg,
          upsell_variant_id: variantId,
          upsell_offer: tag,
          discount_applied: !!data.__disc,
          value: added ? added.final_line_price / 100 : null,
          currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'AUD'
        });
      })
      .catch(function (err) {
        console.error('[cart-upsell]', err);
        button.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', function (evt) {
    var button = evt.target.closest('[data-qt-upsell-add]');
    if (button) addUpsell(button);
  });

  var host = document.getElementById('cart-upsell');
  if (host && window.MutationObserver) {
    new MutationObserver(function () { shownTag = null; noteImpression(); guardSubscription(); }).observe(host, { childList: true });
  }
  noteImpression();
  guardSubscription();
})();
